export default __webpack_public_path__ + "static/media/ProximaNova.a5840a07.woff2";